import { ChevronRight, Users } from "lucide-react";
import { Button } from "../../components/ui/button";
import { MIN_COUNT_TO_DISPLAY } from "./assessmentData";

export default function AssessmentIntro({ steps, completedCount, onStart }) {
  return (
    <div data-testid="assessment-intro" className="text-center">
      <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#0077B3] mb-4">Free Assessment</p>
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-white mb-4" style={{ fontFamily: "Outfit" }}>
        Business Technology Assessment
      </h2>
      <p className="text-[#c0cfe0] text-base max-w-2xl mx-auto mb-8">
        Score your IT, cybersecurity, automation maturity, and operational readiness in under 3 minutes. See where you stand and where the biggest opportunities are.
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 max-w-xl mx-auto mb-8">
        {steps.map((s) => (
          <div key={s.category} className="flex items-center gap-2 text-[#c0cfe0] text-xs">
            <s.icon className="w-3.5 h-3.5 text-[#0077B3]" />
            <span>{s.category}</span>
          </div>
        ))}
      </div>
      <Button
        data-testid="start-assessment-btn"
        onClick={onStart}
        className="bg-[#0077B3] hover:bg-[#005f8f] text-white rounded-md font-bold text-base px-8 h-12"
      >
        Start Assessment <ChevronRight className="w-4 h-4 ml-1" />
      </Button>
      <p className="text-[#c0cfe0]/40 text-xs mt-4">Takes under 3 minutes. No sales pressure.</p>
      {completedCount >= MIN_COUNT_TO_DISPLAY && (
        <p data-testid="assessments-completed-ticker" className="inline-flex items-center gap-1.5 text-[#0077B3] text-xs font-medium mt-4 border border-[#0077B3]/20 bg-[#0077B3]/5 rounded-full px-4 py-1.5">
          <Users className="w-3 h-3" /> Joined by {completedCount}+ businesses who’ve already completed theirs
        </p>
      )}
    </div>
  );
}
